import { useState } from "react";
import { useEffect } from "react";
import styled from "styled-components";
import { colors } from "styles";
import getRandomNumber from "utils/getRandomNumber";
import * as mouseflow from "utils/mouseflow";
import { allowReload, redirect } from "utils/windowRelocation";

const IMAGES = [
  "//www.creditrocket.me/wp-content/uploads/2022/07/chat-img.jpg",
  "//www.creditrocket.me/wp-content/uploads/2022/07/chat-img2.jpg",
  "//www.creditrocket.me/wp-content/uploads/2022/07/chat-img3.jpg",
  "//www.creditrocket.me/wp-content/uploads/2022/07/chat-img4.jpg",
];

const randomImage = IMAGES[getRandomNumber(0, 3)];

const Wrapper = styled.a`
  z-index: 999;
  position: fixed;
  display: block;
  bottom: 20px;
  right: 20px;
  text-decoration: none;

  &,
  &:hover {
    transition: all 200ms ease-in-out;
  }

  &:hover {
    transform: scale(1.1);
  }
`;

const Picture = styled.div`
  position: absolute;
  top: 50%;
  right: 0;
  width: 76px;
  height: 76px;
  border-radius: 76px;
  margin-top: -38px;
  border: solid 2px ${colors.white};
  overflow: hidden;
  background-position: center;
  background-size: cover;
  background-image: ${(props) => `url('${props.src}')`};
  box-shadow: 0 0 15px #0000004d;
  animation-name: scaleUp;
  animation-duration: 350ms;
  animation-timing-function: ease-in-out;

  @keyframes scaleUp {
    from {
      transform: scale(0);
    }
    to {
      transform: scale(1);
    }
  }
`;

const TextWrapper = styled.div`
  overflow: hidden;
  padding: 20px;
  margin-right: 20px;
`;

const Text = styled.div`
  display: flex;
  border-radius: 500px;
  background: ${colors.green};
  color: ${colors.white};
  padding: 10px 45px 10px 10px;
  border: solid 2px ${colors.white};
  box-shadow: 0 0 15px #0000004d;

  animation-name: slideLeft;
  animation-duration: 350ms;
  animation-delay: 200ms;
  animation-timing-function: ease-in-out;
  animation-fill-mode: forwards;

  transform: translateX(120%);

  @keyframes slideLeft {
    from {
      transform: translateX(110%);
    }
    to {
      transform: translateX(0);
    }
  }
`;

const BubbleChat = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const img = new Image();

    img.onload = function () {
      setTimeout(() => {
        setShow(true);
      }, 1000);
    };
    img.src = randomImage;
  }, []);

  if (!show) {
    return null;
  }

  return (
    <Wrapper
      href="sms:+17863295161"
      onClick={(e) => {
        e.preventDefault();

        mouseflow.tag("bubble-chat-click");

        setTimeout(() => {
          redirect("sms:+17863295161");
        }, 0);
      }}
    >
      <TextWrapper>
        <Text>
          <img
            src="//www.creditrocket.me/wp-content/uploads/2022/07/chat.png"
            alt=""
            width="15"
            style={{
              marginRight: 5,
            }}
          />
          ¿Necesita ayuda?
        </Text>
      </TextWrapper>
      <Picture src={randomImage} />
    </Wrapper>
  );
};

export default BubbleChat;
